import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Button,
  message,
  Spin,
  Card,
  Modal,
  Radio,
  Input,
  Space,
  Avatar,
  Tag,
} from "antd";
import _ from "lodash";
import $axios from "../services/axios";
import { useLocation, useHistory } from "react-router-dom";
import goongjs from "@goongmaps/goong-js";
import "@goongmaps/goong-js/dist/goong-js.css";
import * as signalR from "@microsoft/signalr";
import {
  EStatusTrip,
  endPointLocationDrivers,
  canceledTripStatus,
  labelsStatusTrip,
} from "../helpers/const";
import { callPhoneNumber, getPlaceDetailFromLatLng } from "../helpers/utils";
import polyline from "@mapbox/polyline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faArrowLeft,
  faCircleDot,
  faPhone,
  faCircleExclamation,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { openTel } from "../helpers/index";
import moment from "moment";

const Tracking = () => {
  const [modal, contextHolder] = Modal.useModal();
  const location = useLocation();
  const history = useHistory();
  const [bookingInfo, setBookingInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [force, forceUpdate] = useState(false);
  const [imgError, setImgError] = useState(false);
  const mapRef = useRef(null); // Thêm useRef để lưu trữ instance của map
  const markersRef = useRef([]);
  const markerCarRef = useRef(null);
  const markerOverlayRef = useRef(null);
  const [worker, setWorker] = useState(null);
  const [connection, setConnection] = useState(null);
  const statusTripRef = useRef(null);
  const [dataTrip, setDataTrip] = useState(null);
  const driverLocationRef = useRef(null);
  const accessToken = localStorage.getItem("taxiIpassToken");
  const isEndpointDriverRef = useRef(
    endPointLocationDrivers.includes(statusTripRef.current)
  );
  const isCanceledTripRef = useRef(
    canceledTripStatus.includes(statusTripRef.current)
  );
  const forceCancleTripRef = useRef(false);
  const titleRef = useRef(null);
  const queryParams = new URLSearchParams(location.search);
  const setValueForRef = () => {
    isEndpointDriverRef.current = endPointLocationDrivers.includes(
      statusTripRef.current
    );
    isCanceledTripRef.current = canceledTripStatus.includes(
      statusTripRef.current
    );
    titleRef.current = forceCancleTripRef.current
      ? `${labelsStatusTrip[EStatusTrip.CCANCELLED]}`
      : labelsStatusTrip[statusTripRef.current];
  };
  const [estimatedTime, setEstimatedTime] = useState("");

  useEffect(() => {
    if (queryParams.get("orderCode")) {
      fetchBookingInfo();
    } else {
      message.error("Không tìm thấy dữ liệu chuyến đi!");
      history.push("/taxi");
    }
    const newWorker = new Worker("/js/trip-tracking.worker.js");
    setWorker(newWorker);

    return () => {
      newWorker.terminate();
    };
  }, []);

  useEffect(() => {
    if (bookingInfo) {
      initMap();
      initialize();
    }
  }, [bookingInfo]);

  const cancelReasons = [
    "Tôi đã thay đổi kế hoạch",
    "Tôi đã đợi quá lâu",
    "Tài xế yêu cầu huỷ",
    "Tôi muốn thay đổi địa điểm",
    "Lý do khác",
  ];
  const [selectedReason, setSelectedReason] = useState(
    "Tôi đã thay đổi kế hoạch"
  );
  const [otherReason, setOtherReason] = useState("");
  const [openReson, setOpenReason] = useState(false);

  const handleChangeReason = (e) => {
    setSelectedReason(e.target.value);
    if (e.target.value !== "Lý do khác") {
      setOtherReason("");
    }
  };

  const handleOkReason = async () => {
    if (selectedReason === "Lý do khác" && !otherReason) {
      message.error("Vui lòng nhập lý do!");
      return;
    }
    setLoading(true);
    await onCancelTrip(
      selectedReason === "Lý do khác" ? otherReason : selectedReason
    );
    setOpenReason(false);
  };

  const handleCancelReason = () => {
    setOpenReason(false);
  };

  // Kết nối SignalR Hub
  const onConnectionHub = useCallback(
    async (callback) => {
      try {
        if (connection) return;

        const newConnection = new signalR.HubConnectionBuilder()
          .withUrl(`${process.env.REACT_APP_BASE_URL}/taxi-notification`, {
            withCredentials: true,
            accessTokenFactory: () => process.env.REACT_APP_VERIFY_TOKEN,
          })
          .withAutomaticReconnect([0, 2000, 5000, 10000])
          .build();

        await newConnection.start();
        if (newConnection.state === "Connected") {
          await newConnection.invoke("JoinRoom", bookingInfo.orderCode);
          newConnection.on("StatusTrip", callback);
          setConnection(newConnection);
        }
      } catch (error) {
        console.error("SignalR connection error:", error);
      }
    },
    [connection, bookingInfo]
  );

  // Theo dõi chuyến đi
  const onCheckTrackingTrip = async (callback, callbackGetDetail) => {
    if (!worker) {
      const newWorker = new Worker("/js/trip-tracking.worker.js");
      setWorker(newWorker);
    }

    worker?.postMessage(
      JSON.stringify({
        tripId: bookingInfo.tripId,
        accessToken,
        type: "tracking",
      })
    );

    const handleWorkerMessage = async ({ data }) => {
      if (data) {
        if (statusTripRef.current !== data.data.status) {
          statusTripRef.current = data.data.status;
          await callbackGetDetail();
          // setDriverLocation(data.data.tracking);
          driverLocationRef.current = data.data.tracking;
          return;
        }
        statusTripRef.current = data.data.status;
        // setDriverLocation(data.data.tracking);
        driverLocationRef.current = data.data.tracking;
        setValueForRef();
        forceUpdate((prev) => !prev);
        callback();
      }
    };

    worker?.addEventListener("message", handleWorkerMessage);
    return () => worker?.removeEventListener("message", handleWorkerMessage);
  };

  // Hủy theo dõi
  const onClearTrackingTrip = () => {
    worker?.postMessage({
      tripId: bookingInfo.partnerTripId,
      accessToken,
      type: "clear",
    });
  };

  // Chi tiết chuyến đi
  const onGetDetailTrip = async () => {
    try {
      const res = await $axios.get(
        `/api/v1/gsm/trip?tripId=${bookingInfo.tripId}`
      );
      if (res) {
        setDataTrip(res.data.data);
        statusTripRef.current = res.data.data.status;
        setValueForRef();
        forceUpdate((prev) => !prev);
      }
    } catch (error) {
      // message.error(
      //   error.response.data.message || "Không tìm thấy dữ liệu chuyến đi!"
      // );
    }
  };

  // Gọi tài xế
  const onCallDriver = () => {
    if (dataTrip?.driver.phoneNumber) {
      // callPhoneNumber(dataTrip.driver.phoneNumber);
      openTel(dataTrip.driver.phoneNumber);
    }
  };

  // Hủy chuyến
  const onCancelTrip = async (reason) => {
    setLoading(true);
    try {
      onClearTrackingTrip();
      const res = await $axios.$post("/api/v1/gsm/payment/cancel", {
        tripId: bookingInfo.tripId,
        reasonId: 1,
        otherContent: reason,
      });
      if (res) {
        statusTripRef.current = EStatusTrip.CANCELLED;
        setValueForRef();
        forceCancleTripRef.current = true;
        forceUpdate((prev) => !prev);
      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 4000);
    }
  };

  // Cleanup effect
  useEffect(() => {
    return () => {
      worker?.terminate();
      connection?.stop();
    };
  }, [worker, connection]);

  const onRebookCar = async () => {
    setLoading(true);
    try {
      window.location.href = `/taxi`;
    } catch (error) {
      message.error("Đã có lỗi xảy ra! Vui lòng thử chuyến đi khác");
      setLoading(false);
    }
  };

  const fetchBookingInfo = async () => {
    try {
      setLoading(true);
      const res = await $axios.$get(
        `/api/v1/gsm/transactions/details?orderCode=${queryParams.get(
          "orderCode"
        )}`
      );
      if (res.data.data.data) {
        setBookingInfo(res.data.data.data);
      } else {
        message.error("Không tìm thấy dữ liệu!");
        history.push("/taxi");
      }
    } catch (error) {
      message.error(error.response.data.message || "Không tìm thấy dữ liệu!");
      history.push("/taxi");
    } finally {
      setLoading(false);
    }
  };

  const initMap = () => {
    setLoading(true);
    goongjs.accessToken = "6twIVlSlDTMzUHQNmIwhtQ3Kse88gqZN3JwnHhbN";
    mapRef.current = new goongjs.Map({
      container: "map",
      center: [bookingInfo.startPointY, bookingInfo.startPointX],
      zoom: 15,
      style: "https://tiles.goong.io/assets/goong_map_web.json",
      attributionControl: false,
    });

    mapRef.current.on("load", () => {
      setLoading(false);
    });
  };

  const initialize = async () => {
    onClearTrackingTrip();
    await onGetDetailTrip();
    await reRoute();

    const trackingInterval = onCheckTrackingTrip(onUpdateMarker, async () => {
      await onGetDetailTrip();
      await reRoute();
      if (
        isCanceledTripRef.current ||
        [
          EStatusTrip.PAID,
          EStatusTrip.FINISHED,
          EStatusTrip.TIMEOUT,
          EStatusTrip.NOT_FOUND,
          EStatusTrip.MISSED,
        ].includes(statusTripRef.current)
      ) {
        setValueForRef();
        onClearTrackingTrip();
      }
      if (
         isCanceledTripRef.current ||
         [
           EStatusTrip.TIMEOUT,
           EStatusTrip.NOT_FOUND,
           EStatusTrip.MISSED,
         ].includes(statusTripRef.current)
       ) {
          handleCancelPayment();
       }
      console.log(statusTripRef.current,'statusTripRef');
    });

    return () => {
      onClearTrackingTrip();
      if (trackingInterval) {
        clearInterval(trackingInterval);
      }
    };
  };

  const createCustomMarker = (iconUrl, size) => {
    const el = document.createElement("div");
    el.className = "custom-marker";
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.backgroundSize = "cover";
    return el;
  };

  const createMarker = (latlng, icon, content, size = 20) => {
    // @ts-ignore
    const marker = new goongjs.Marker({
      element: createCustomMarker(icon, size),
    })
      .setLngLat([latlng.lng, latlng.lat])
      .addTo(mapRef.current);

    // @ts-ignore
    const popup = new goongjs.Popup({ offset: 25 }).setHTML(content);

    marker.setPopup(popup);
    popup.addTo(mapRef.current);
    markersRef.current.push(marker);
  };

  const calculateAndDisplayRoute = async () => {
    if (markersRef.current.length > 0) {
      markersRef.current.forEach((marker) => {
        marker.remove();
      });
      markerCarRef.current?.remove();
      markerCarRef.current = null;
      markersRef.current = [];
    }

    if (markerOverlayRef.current) {
      markerOverlayRef.current.remove();
    }

    const origin = {
      lat:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.x
          : bookingInfo.startPointX,
      lng:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.y
          : bookingInfo.startPointY,
    };
    const destination = {
      lat: isEndpointDriverRef.current
        ? driverLocationRef.current?.x
        : bookingInfo.endPointX,
      lng: isEndpointDriverRef.current
        ? driverLocationRef.current?.y
        : bookingInfo.endPointY,
    };

    let layers = mapRef.current?.getStyle().layers;
    let firstSymbolId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol") {
        firstSymbolId = layers[i].id;
        break;
      }
    }

    const res = await $axios.$get(
      `https://rsapi.goong.io/Direction?origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&vehicle=car&api_key=${process.env.REACT_APP_GOOGNG_API_KEY}`
    );
    if (res.data.routes && res.data.routes.length > 0) {
      const leg = res.data.routes[0].legs[0];
      const route = res.data.routes[0];
      const geometry_string = route.overview_polyline.points;
      const geoJSON = polyline.toGeoJSON(geometry_string);
      mapRef.current?.addSource("route", {
        type: "geojson",
        data: geoJSON,
      });

      mapRef.current?.addLayer(
        {
          id: "route",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#1e88e5",
            "line-width": 5,
          },
        },
        firstSymbolId
      );
      if (statusTripRef.current === EStatusTrip.JOURNEY) {
        const el = document.createElement("div");
        el.innerHTML = `<div id="markerCar">
                            <img src="/images/car-icon.png" style="width: 26px;" />
                          </div>`;
        markerCarRef.current = new goongjs.Marker({ element: el })
          .setLngLat([
            driverLocationRef.current?.y,
            driverLocationRef.current?.x,
          ])
          .addTo(mapRef.current);
      } else {
        createMarker(
          leg.start_location,
          "/images/person-wave-hand.png",
          bookingInfo.startPointName
        );
      }
      if (isEndpointDriverRef.current) {
        const el = document.createElement("div");
        el.innerHTML = `<div id="markerCar">
                            <img src="/images/car-icon.png" style="width: 26px;" />
                          </div>`;
        markerCarRef.current = new goongjs.Marker({ element: el })
          .setLngLat([
            driverLocationRef.current?.y,
            driverLocationRef.current?.x,
          ])
          .addTo(mapRef.current);
      } else {
        createMarker(
          leg.end_location,
          "/images/flag-icon.svg",
          bookingInfo.endPointName,
          50
        );

        if (statusTripRef.current === EStatusTrip.FINDING) {
          const el = document.createElement("div");
          el.innerHTML = ` <div class="scan-box"></div>`;
          markerOverlayRef.current = new goongjs.Marker({ element: el })
            .setLngLat([origin.lng, origin.lat])
            .addTo(mapRef.current);
        }
      }
    }
  };

  const onHandleMap = async () => {
    const currentCenter = mapRef.current?.getCenter();
    const currentZoom = mapRef.current?.getZoom();

    if (mapRef.current?.getLayer("route")) {
      mapRef.current?.removeLayer("route");
    }
    if (mapRef.current?.getSource("route")) {
      mapRef.current?.removeSource("route");
    }

    await calculateAndDisplayRoute();
    mapRef.current?.setCenter(currentCenter);
    mapRef.current?.setZoom(currentZoom);
  };

  const onUpdateMarker = async () => {
    const markerCarEl = document.getElementById("markerCar");

    const origin = {
      lat:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.x
          : bookingInfo.startPointX,
      lng:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.y
          : bookingInfo.startPointY,
    };
    const destination = {
      lat: isEndpointDriverRef.current
        ? driverLocationRef.current?.x
        : bookingInfo.endPointX,
      lng: isEndpointDriverRef.current
        ? driverLocationRef.current?.y
        : bookingInfo.endPointY,
    };

    const res = await $axios.$get(
      `https://rsapi.goong.io/Direction?origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&vehicle=car&api_key=${process.env.REACT_APP_GOOGNG_API_KEY}`
    );
    setEstimatedTime(res?.data.routes?.[0]?.legs?.[0]?.duration?.text || "");

    if (
      statusTripRef.current === EStatusTrip.JOURNEY &&
      !!markerCarRef.current
    ) {
      markerCarRef.current.setLngLat([
        driverLocationRef.current?.y,
        driverLocationRef.current?.x,
      ]);
      if (markerCarEl) {
        markerCarEl.style.transform = `rotate(${Number(
          driverLocationRef.current?.orientation
        )}deg)`;
      }
    }

    if (isEndpointDriverRef.current && !!markerCarRef.current) {
      markerCarRef.current.setLngLat([
        driverLocationRef.current?.y,
        driverLocationRef.current?.x,
      ]);
      if (markerCarEl) {
        markerCarEl.style.transform = `rotate(${Number(
          driverLocationRef.current?.orientation
        )}deg)`;
      }
    }
  };

  const reRoute = async () => {
    try {
      const res = await $axios.$get(
        `/api/v1/gsm/trip/tracking?tripId=${bookingInfo.tripId}`
      );
      if (res) {
        statusTripRef.current = res.data.data.status;
        // setDriverLocation(res.data.data.tracking);
        driverLocationRef.current = res.data.data.tracking;
        setValueForRef();
        forceUpdate((prev) => !prev);
        await onHandleMap();
      }
    } catch (error) {
      // message.error(
      //   error.response.data.message || "Không tìm thấy dữ liệu chuyến đi!"
      // );
    }
  };

  const handleCancelPayment = async () => {
    setLoading(true);
    try {
      await $axios.$post("/api/v1/gsm/payment/cancel", {
        tripId: bookingInfo.tripId,
        reasonId: 1,
        otherContent:  "cancelled the trip",
      });
    } catch (error) {
      console.log(error.response?.data)
    }
    finally {
      setLoading(false);
    }
  };

  const focusCurrentLocation = () => {
    const origin = {
      lat:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.x
          : bookingInfo.startPointX,
      lng:
        statusTripRef.current === EStatusTrip.JOURNEY
          ? driverLocationRef.current?.y
          : bookingInfo.startPointY,
    };
    mapRef.current?.setCenter(origin);
    mapRef.current?.setZoom(15);
  };

  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      <div className="relative flex flex-col h-[100vh] bg-white">
        <div id="map" className="flex-1 max-h-[100%]"></div>
        {statusTripRef.current === EStatusTrip.FINDING && (
          <div class="marker-center">
            <img src="/images/mark.svg" alt="icon" class="w-4" />
          </div>
        )}
        <div className="flex flex-col h-auto relative">
          <div className="flex justify-between absolute top-[-40px] w-full px-4">
            <Button color="primary" variant="outlined">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-primary"
                onClick={() => {
                  window.location.href = "/taxi";
                }}
              />
            </Button>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => focusCurrentLocation()}
            >
              <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
                <defs></defs>
                <g
                  id="Home-2"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="1-Home"
                    transform="translate(-259.000000, -279.000000)"
                  >
                    <g
                      id="ic_current"
                      transform="translate(259.000000, 279.000000)"
                    >
                      <circle
                        id="Oval"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="#FFFFFF"
                        cx="8.5"
                        cy="8.5"
                        r="7.5"
                      ></circle>
                      <circle
                        id="Oval"
                        fill="currentColor"
                        cx="8.5"
                        cy="8.5"
                        r="4.25"
                      ></circle>
                    </g>
                  </g>
                </g>
              </svg>
            </Button>
          </div>
          <Card
            className="tracking-card"
            bodyStyle={{
              padding: "16px",
            }}
            title={
              <div className="text-left">
                <div className="flex gap-2 justify-between">
                  <div className="text-[14px] font-semibold">
                    {titleRef.current}
                  </div>
                  {(isEndpointDriverRef.current ||
                    statusTripRef.current === EStatusTrip.JOURNEY) && (
                    <Tag className="bg-primary text-white" size="large">
                      <span className="text-white">{estimatedTime}</span>
                    </Tag>
                  )}
                </div>
                {statusTripRef.current === EStatusTrip.FINDING &&
                  !forceCancleTripRef.current && (
                    <div className="text-[14px] font-light">
                      Đang kết nối với tài xế xung quanh...
                    </div>
                  )}
              </div>
            }
          >
            <div className="flex flex-col gap-3 mb-3">
              <div className="text-[14px] font-light">
                {moment(bookingInfo?.createdAt).format("DD/MM/YYYY HH:mm")}
              </div>
              <div className="flex gap-1">
                <FontAwesomeIcon
                  icon={faCircleDot}
                  className="text-primary text-[14px] mt-1"
                />
                <div>
                  <div className="ml-2">
                    <p className="text-[14px] font-semibold text-ellipsis overflow-hidden whitespace-nowrap">
                      {bookingInfo?.startPointName}
                    </p>
                    <p className="text-[14px] font-normal line-clamp-2">
                      {bookingInfo?.startPointGeocode}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex gap-1">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="text-yellow-600 text-[16px] mt-1"
                />
                <div>
                  <div className="ml-2">
                    <p className="text-[14px] font-semibold text-ellipsis overflow-hidden whitespace-nowrap">
                      {bookingInfo?.endPointName}
                    </p>
                    <p className="text-[14px] font-normal line-clamp-2">
                      {bookingInfo?.endPointGeocode}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {([
              EStatusTrip.TIMEOUT,
              EStatusTrip.NOT_FOUND,
              EStatusTrip.MISSED,
              EStatusTrip.FINISHED,
            ].includes(statusTripRef.current) ||
              isCanceledTripRef.current) && (
              <Button
                onClick={() => onRebookCar()}
                type="primary"
                size="large"
                style={{ height: 40 }}
                className="w-full"
              >
                <span className="text-[16px] font-semibold">
                  Đặt chuyến khác
                </span>
              </Button>
            )}
            {(statusTripRef.current === EStatusTrip.FINDING ||
              statusTripRef.current === EStatusTrip.COMING) &&
              !forceCancleTripRef.current && (
                <>
                  <Button
                    type="primary"
                    onClick={() => setOpenReason(true)}
                    className="w-full my-2"
                    size="large"
                  >
                    <span className="text-[14px] font-semibold">
                      Huỷ chuyến
                    </span>
                  </Button>
                </>
              )}

            {(isEndpointDriverRef.current ||
              statusTripRef.current === EStatusTrip.JOURNEY) && (
              <div className="flex flex-col">
                <div className="flex gap-4 items-center justify-between w-full">
                  <Avatar
                    size={64}
                    src={
                      !imgError
                        ? dataTrip?.driver?.avatar
                        : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                    }
                    onError={() => {
                      setImgError(true);
                      return false;
                    }}
                  />
                  <div className="flex flex-col gap-1 flex-1 text-left">
                    <div className="text-[14px] font-medium text-primary">
                      {dataTrip?.driver?.fullName}
                    </div>
                    <Button
                      size="small"
                      variant="filled"
                      className="bg-yellow-300 w-16 text-[14px] border-0"
                    >
                      <FontAwesomeIcon
                        icon={faStar}
                        className="text-yellow-600 text-[14px]"
                      />
                      {dataTrip?.driver?.rating}
                    </Button>
                    <div className="text-[14px] font-medium">
                      {dataTrip?.driver?.officeBrand}
                    </div>
                    <div className="text-[14px] font-medium">
                      {dataTrip?.vehicle?.brand} {dataTrip?.vehicle?.model} -{" "}
                      {dataTrip?.vehicle?.color}
                    </div>
                    <div className="text-[14px] font-medium">
                      {dataTrip?.vehicle?.licensePlate}
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 items-center">
                    <Button
                      onClick={() => onCallDriver()}
                      variant="solid"
                      className="bg-primary max-w-[58px]"
                      type="primary"
                    >
                      <FontAwesomeIcon
                        icon={faPhone}
                        className="text-white text-[16px]"
                      />
                    </Button>
                    <div>
                      {dataTrip?.driver.phoneNumber.replace("+84", "0")}
                    </div>
                  </div>
                </div>
                {/* <div className="border-t border-t-gray-300 flex px-4 pt-4">
                  <div className="ml-2">
                    <p className="text-[16px] font-semibold text-ellipsis overflow-hidden whitespace-nowrap">
                      {dataTrip?.booking.waypoints[1].text}
                    </p>
                    <p className="text-[16px] mt-1 line-clamp-2">
                      {dataTrip?.booking.waypoints[1].geocode}
                    </p>
                  </div>
                </div> */}
                {/* {isEndpointDriverRef.current && (
                  <Button
                    type="primary"
                    onClick={() => setOpenReason(true)}
                    className="w-full mt-2"
                    size="large"
                  >
                    <span className="text-[14px] font-semibold">
                      Huỷ chuyến
                    </span>
                  </Button>
                )} */}
              </div>
            )}
          </Card>
        </div>
        <Modal
          confirmLoading={loading}
          title={
            <span className="flex items-center text-lg font-semibold text-primary">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                className="text-primary mr-2"
              />
              Bạn muốn huỷ chuyến?
            </span>
          }
          open={openReson}
          onOk={() => handleOkReason()}
          onCancel={() => handleCancelReason()}
          okText="Huỷ chuyến"
          cancelText="Giữ chuyến"
          okButtonProps={{
            type: "primary",
          }}
        >
          <div className="flex flex-col items-center justify-center gap-4">
            <img src="/images/5seat.webp" alt="car" />
            <div className="text-[14px] font-medium text-center">
              Tài xế đang trên đường đón bạn. Vui lòng chỉ huỷ cuốc xe trong các
              trường hợp bất khả kháng.
            </div>

            <div className="flex flex-col w-full">
              <Radio.Group onChange={handleChangeReason} value={selectedReason}>
                <Space direction="vertical">
                  {cancelReasons.map((reason) => (
                    <Radio key={reason} value={reason}>
                      {reason}
                    </Radio>
                  ))}
                </Space>
              </Radio.Group>
              {selectedReason === "Lý do khác" && (
                <Input
                  style={{ marginTop: 8, width: "100%" }}
                  placeholder="Nhập lý do khác..."
                  value={otherReason}
                  onChange={(e) => setOtherReason(e.target.value)}
                />
              )}
            </div>
          </div>
        </Modal>
      </div>
    </Spin>
  );
};

export default Tracking;
